import { useState } from "react";
import API from "app/services/api";
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";

export const useAPI = () => {
  // Esse hook vai servir para nós não repetirmos tanto código quando chamarmos a API pelo projeto
  const [responseData, setResponseData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const Swal = useSwalWrapper();

  const toast = (variant, message, type = false) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      onOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    });

    Toast.fire({
      icon: variant,
      title: message,
      showCloseButton: true,
      closeButtonAriaLabel: "Fechar",
      timer: 3000,
    });
  };

  const makeRequest = async (url, method = "GET", data = {}, config = {}, onSuccess) => {
    setLoading(true);
    setError(null);
    try {
      let requestConfig = {
        method,
        url,
        ...config,
      };
      if (method === "POST" || method === "PUT") {
        requestConfig = { ...requestConfig, data };
        // Se for FormData, não sobrescrever Content-Type
        if (data instanceof FormData && requestConfig.headers && requestConfig.headers["Content-Type"]) {
          delete requestConfig.headers["Content-Type"];
        }
      }
      const response = await API.request(requestConfig);
      
      if (response.status === 200 || response.status === 201) {
        setResponseData(response.data);
        if (method === "POST" || method === "PUT") {
          toast("success", "Sucesso!", "success");
        }
        setSuccess(true);
        if (typeof onSuccess === 'function') {
          onSuccess(response);
        }
        return response;
      } else {
        setSuccess(false);
        throw new Error("Falha na requisição!");
      }
    } catch (err) {
      const messageError =
        err.response?.data?.message || "Ocorreu um erro desconhecido.";
      const errorStatus = err.response?.data?.statusCode || err.response?.status;
      toast("error", messageError, "error");
      setError(err.message || "Ocorreu um erro desconhecido.");
      const errorResponse = {
        status: errorStatus,
        message: messageError,
      };
      return errorResponse;
    } finally {
      setLoading(false);
    }
  };

  return { responseData, loading, error, success, makeRequest };
};
